module.exports = __webpack_public_path__ + "shanz/static/media/aboutT.985089ff.png";